import { Button } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  faEnvelope,
  faPenToSquare,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Kontakt() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center justify-between">
        <h2 className="text-neutrals-900 text-base font-bold leading-6 wrap-break-word">
          {t('domain.mitarbeiter.create.steps.person.kontakt.title')}
        </h2>
        <Button
          variant={'icon'}
          onClick={() => ctx.navigateToSubStep('person.kontakt')}>
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="text-primary-blue-600"
          />
        </Button>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-1">
          <FontAwesomeIcon icon={faEnvelope} />
          <span className="text-neutrals-900 text-sm font-semibold leading-5">
            {data.person.kontakt.email || '-'}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-1">
          <FontAwesomeIcon icon={faPhone} />
          <span className="text-neutrals-900 text-sm font-semibold leading-5">
            {data.person.kontakt.mobilnummer || '-'}
          </span>
        </div>
      </div>
    </div>
  );
}
